import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import _ from "lodash";
import MenuHorizontal from "./MenuHorizontal";
import api from "../../api/apiUtil";
import { toastr } from "react-redux-toastr";
class Header extends React.Component {
  render() {
    return (
      <div id="header">
        <div className="color-line  " />
        <div id="logo" className="light-version" style={process.env.REACT_APP_LOGO_BACKGROUND_COLOR ? { backgroundColor: process.env.REACT_APP_LOGO_BACKGROUND_COLOR } : {}}>
          {process.env.REACT_APP_LOGO_URL ? (
            <img alt="" src={process.env.REACT_APP_LOGO_URL} className="mr-3 align-self-center mx-auto" style={{ maxHeight: "30px" }} />
          ) : (
            <span>{this.props.header && this.props.header !== null ? this.props.header : "E-Registro"}</span>
          )}
          {this.props.currentUser && this.props.currentUser.idFinanceira && (
            <spam style={{ lineHeight: "-0.5" }}>
              <br />
              Portal Financeira
            </spam>
          )}
          {_.findIndex(this.props.currentUser.perfis, function (perfil) {
            return perfil === "ALIAS";
          }) > -1 && (
            <spam style={{ lineHeight: "-0.5" }}>
              <br />
              Portal Administrativo
            </spam>
          )}
        </div>
        {this.props.orientacaoMenu && this.props.orientacaoMenu === "1" ? (
          <div>
            <nav class="navbar navbar-dark bg-dark">
              <MenuHorizontal />
              <span className="row float-right align-items-center">
                {this.props.currentUser && <h6 className="font-bold m-t-sm m-r-md class-font-text">{this.props.currentUser.nome}</h6>}
                <Link to="/secure/profile" class="class-font-text">
                  <i title="Perfil" className="far fa-user fa-2x m-t-sm m-r-md"></i>
                </Link>
                <Link onClick={this.handleVideoClick.bind(this)}>
                  <i title="Ajuda" className="far fa-question-circle fa-2x m-t-sm m-r-md"></i>
                </Link>
                <Link to={"https://www.aliasnet.com.br/wp-content/uploads/2020/08/Manual_Usuario_e-Registro.pdf"} target="_blank" class="class-font-text">
                  <i title="Acessar manual" className="far fa-file-alt fa-2x m-t-sm m-r-lg"></i>
                </Link>
                <Link onClick={this.handleLogoutClick.bind(this)} class="class-font-text">
                  <i title="Sair" className="fas fa-sign-out-alt fa-2x m-t-sm m-r-lg"></i>
                </Link>
              </span>
            </nav>
          </div>
        ) : (
          <div className="row float-right align-items-center">
            {this.props.currentUser && <h6 className="font-bold m-t-sm m-r-md class-font-text">{this.props.currentUser.nome}</h6>}
            {/*{ (process.env.REACT_APP_HELP_URL && ((_.findIndex(this.props.currentUser.perfis, function(perfil) { return perfil === 'ADMIN'; }) > -1) || (_.findIndex(this.props.currentUser.perfis, function(perfil) { return perfil === 'OPER'; }) > -1)) ) ?
          <a target="_blank" href={process.env.REACT_APP_HELP_URL}>
              <i className="far fa-lightbulb fa-2x m-t-sm m-r-md" ></i>
          </a>
          :
          <div></div>
          }*/}
            {/* <Link onClick={this.handleClickOpenBug.bind(this)} class="class-font-text">
              <i title="Abrir chamado" className="fas fa-bullhorn fa-2x m-t-sm m-r-lg"></i>
            </Link> */}
            <Link to="/secure/profile" class="class-font-text">
              <i title="Perfil" className="far fa-user fa-2x m-t-sm m-r-md"></i>
            </Link>
            {/* <Link onClick={this.handleVideoClick.bind(this)} class="class-font-text">
              <i title="Ajuda" className="far fa-question-circle fa-2x m-t-sm m-r-md"></i>
            </Link> */}
            <Link to={"https://aliasnet.com.br/videos/"} target="_blank" class="class-font-text">
              <i title="Ajuda" className="far fa-question-circle fa-2x m-t-sm m-r-md"></i>
            </Link>
            <Link to={"https://aliasnet.com.br/wp-content/uploads/2025/03/19-20.-Manual-do-Usuario-2.pdf"} target="_blank" class="class-font-text">
              <i title="Acessar manual" className="far fa-file-alt fa-2x m-t-sm m-r-lg"></i>
            </Link>
            <Link to={"https://aliasnet.com.br/e-registro/?v=2"} target="_blank" class="class-font-text">
              <i title="FAQ" className="far fa-newspaper fa-2x m-t-sm m-r-lg"></i>
            </Link>
            <Link to={"https://aliasnet.com.br/informacoes-juridicas/"} target="_blank" class="class-font-text">
              <i title="Informações Jurídicas" className="fas fa-exclamation fa-2x m-t-sm m-r-lg"></i>
            </Link>
            <Link onClick={this.handleLogoutClick.bind(this)} class="class-font-text">
              <i title="Sair" className="fas fa-sign-out-alt fa-2x m-t-sm m-r-lg"></i>
            </Link>
          </div>
        )}
      </div>
    );
  }

  handleLogoutClick(event) {
    event.preventDefault();
    this.props.logout();
  }

  handleVideoClick(event) {
    event.preventDefault();
    this.props.video();
  }

  handleClickOpenBug(event) {
    event.preventDefault();
    this.props.openBug({
      description: `Abrir novo chamado`,
      onSuccess: this.clickOpenBug.bind(this),
      justification: true,
      descriptionJustification: "descrição:",
    });
  }

  clickOpenBug = (params) => {
    var props = this.props;
    Promise.resolve(api.Contracts.abrirChamado({ mensagem: params.justificativa }))
      .then((ret) => {
        toastr.success("Sucesso", "Chamado aberto, aguarde o contato da nossa equipe!");
      })
      .catch((ret) => {
        if (ret === "jwt expired" || ret.message === "Unauthorized" || ret.message === "jwt expired") {
          api.Auth.logout();
          props.logout();
        } else if (ret.response && ret.response.body && ret.response.body.message) {
          toastr.error("Erro", ret.response.body.message);
        } else {
          toastr.error("Erro", "Ocorreu um erro ao realizar a operação!");
        }
      });
  };
}

Header.propTypes = {
  logout: PropTypes.func.isRequired,
  video: PropTypes.func.isRequired,
  currentUser: PropTypes.object,
  header: PropTypes.string.isRequired,
  orientacaoMenu: PropTypes.string.isRequired,
  openBug: PropTypes.func.isRequired,
};

export default Header;
